import {twMerge} from '@sdox/utils'

import type {DialogContentProps} from './Dialog'

export const DialogContent = ({children, className, hasAside, ...restProps}: DialogContentProps) => (
  <div
    className={twMerge('flex', hasAside ? 'flex-col-reverse sm:flex-row' : 'flex-col', className)}
    {...restProps}
  >
    {children}
  </div>
)
